import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class InvoiceAccountantAreaService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination }) {
    const url = `/proxy/organizations/${companyUuid}`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async create(body) {
    return await this.post(`/proxy/series`, body);
  }

  async deactivate(serie_id) {
    return await this.update(`/proxy/series/${serie_id}`, { active: false });
  }

  async activate(serie_id) {
    return await this.update(`/proxy/series/${serie_id}`, { active: true });
  }

  async getActiveSerie(companyUuid) {
    return await this.get(`/proxy/series/company/${companyUuid}`);
  }

  async getAllSeries(companyUuid) {
    return await this.get(`/proxy/series/company/${companyUuid}?all=true`);
  }
}

export default InvoiceAccountantAreaService;



// WEBPACK FOOTER //
// ./src/core/service/invoice-accountant-area.service.js